var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollBox",staticClass:"scroll-box",class:[_vm.hiddenScrollBar],on:{"mouseover":_vm.onMouseover,"mouseleave":_vm.onMouseleave}},[_c('div',{ref:"scrollMain",staticClass:"scroll-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }